import classNames from "classnames";

export interface SimpleTableColumn {
  label: React.ReactNode;
  className?: string;
}

interface SimpleTableProps {
  columns: SimpleTableColumn[];
  children: React.ReactNode;
  className?: string;
}

export function SimpleTable({
  columns,
  children,
  className,
}: SimpleTableProps) {
  return (
    <table className={classNames("w-full text-sm", className)}>
      <thead>
        <tr className="border-b text-left text-gray-500">
          {columns.map((col, i) => (
            <th
              key={i}
              className={classNames("py-2 font-medium", col.className)}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}

export function SimpleTableRow({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLTableRowElement>) => void;
}) {
  const interactive = typeof onClick === "function";
  return (
    <tr
      className={classNames(
        "border-b",
        { "cursor-pointer hover:bg-gray-50 transition-colors": interactive },
        className,
      )}
      onClick={onClick}
      role={interactive ? "link" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick?.(
                  event as unknown as React.MouseEvent<HTMLTableRowElement>,
                );
              }
            }
          : undefined
      }
    >
      {children}
    </tr>
  );
}

export function SimpleTableCell({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <td className={classNames("py-2", className)}>{children}</td>;
}
